import { render, staticRenderFns } from "./checkboxCheck.vue?vue&type=template&id=525b80a4&"
import script from "./checkboxCheck.vue?vue&type=script&lang=js&"
export * from "./checkboxCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports